import { URLS } from 'api/constants';
import { IQuestion } from 'constants/types';
import { apiGet, apiGetSafe } from './client';
import { PaginationRequest, PaginationResponse } from './types';

type ApiParams = Record<string, string | number | boolean | undefined | null>;

export async function getQuestionById(id?: string) {
  return apiGetSafe<IQuestion>(`${URLS.QUESTIONS}${id ?? ''}`);
}

export async function listQuestions(params: PaginationRequest = {}) {
  return apiGet<PaginationResponse<IQuestion>>(
    URLS.QUESTIONS,
    params as ApiParams
  );
}

export async function listQuestionsByCasino(id: string) {
  return apiGet<PaginationResponse<IQuestion>>(
    `${URLS.QUESTIONS_BY_CASINO}${id}`
  );
}
